import { useState, useEffect } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { isCanceled, logApiError } from 'services/apiError'
import useAbortController from 'hooks/useAbortController'
import useDebouncedValue from 'hooks/useDebouncedValue'
import DateInput from 'components/Inputs/DateInput'
import TextInput from 'components/Inputs/TextInput'
import BusinessBillList from 'components/Lists/BusinessBillList'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { DateTime } from 'luxon'
import { ListContainer, Row } from '../styles'

export default function ClosedBills () {
  const token = AuthService.getToken ()
  const businessId = AuthService.getBusinessId ()
  const [loading, setLoading] = useState (true)
  const [date, setDate] = useState (DateTime.now ().toISODate ())
  const [customerName, setCustomerName] = useState ('')
  const debouncedCustomerName = useDebouncedValue(customerName, 500)
  const { abortarPendentes } = useAbortController()
  const [closedBills, setClosedBills] = useState ([])

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    getData ()
  }, [date, debouncedCustomerName])

  const getData = async () => {
    const signal = abortarPendentes()

    try {
      setLoading (true)

      const filters = `deleted=false&date=${date}&open=false&customer_name=${encodeURIComponent(debouncedCustomerName)}`

      const { data: closedBills } = await cutileiApi.get (
        `/business_bills?business_id=${businessId}&${filters}`,
        { ...requestConfig, signal }
      )

      setClosedBills (closedBills)
    } catch (error) {
      if (isCanceled(error)) return
      logApiError (error)
    } finally {
      if (!signal.aborted) setLoading (false)
    }
  }
  
  const handleEditBill = bill => {
    setClosedBills (closedBills.map (b => b.id === bill.id ? bill : b))
  }

  const handleDeleteBill = bill => {
    setClosedBills (closedBills.filter (b => b.id !== bill.id))
  }

  return (
    <ListContainer>
      <Row style={{marginBottom: 15}}>
        <DateInput
          placeholder='Data'
          value={date ? DateTime.fromISO (date) : null}
          onChange={setDate}
          style={{width: 180}}
        />
        <TextInput
          value={customerName}
          placeholder='Buscar por cliente'
          isClearable={true}
          onChange={e => setCustomerName (e.target.value)}
          onClear={() => setCustomerName ('')}
          inputStyle={{boxShadow: '0px 1px 10px -6px', paddingInline: 12}}
          containerStyle={{width: 280}}
        />
      </Row>
      {loading ? <Loading/> : (
        <BusinessBillList
          bills={closedBills}
          onEdit={handleEditBill}
          onCloseBill={handleEditBill}
          onDelete={handleDeleteBill}
        />
      )}
    </ListContainer>
  )
}
